import { Box, BrandLogoCouponsPage, FloatingInput, Form, OffersMailIconWMO, ThemeContextExtend, useResponsiveWrapperContext } from '@usap/uicomponents'
import React, { useState, useCallback, useEffect } from 'react'
import FormTheme from './config/form-theme'
import {
  CouponsInnerContainer,
  CouponsMainContainer,
  CouponTitleContainer,
  CouponsText,
  CouponsTextContainer,
  HeadingText,
  SignUpNowBtn,
  CouponLinksContainer,
  LinkText,
} from './style/CouponsWMO.css'
import { subscribeSchema } from './ValidationSchema'
import validate from '@usap/core/src/helpers/validation'

const CouponsWMO = ({
  onSubscribe,
  setMessage,
  Link,
  couponsData,
}) => {
  const [errors, setError] = useState({})
  const [formData, setFormData] = useState({
    emailAddress: '',
    source: 'coupons_page',
  })
  const [focusedInput, setFocusedInput] = useState('')
  const [isFormValid, setIsFormValid] = useState(false)
  const { isDesktop } = useResponsiveWrapperContext()

  const onInputChangeHandler = (name, value) => {
    setMessage('')
    setError({
      ...errors,
      [name]: '',
    })
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const onFormSubmit = useCallback(() => {
    const hasError = validate(formData, subscribeSchema(formData))
    if (hasError) {
      return setError(hasError)
    }
    return onSubscribe(formData)
  }, [formData, onSubscribe])

  const onBlurForEmail = useCallback(name => {
    const currentForm = {
      ...formData,
    }
    const hasError = validate(currentForm, subscribeSchema(currentForm))
    if (hasError) {
      setError({ ...errors, [name]: hasError[name] })
    }
  }, [errors, formData])

  const resetClick = (name, event) => {
    event.target.name = name
    event.target.value = ''
    onInputChangeHandler(name, event.target.value)
    setFormData({ ...formData, [name]: '' })
  }
  const onBlurFun = useCallback(
    event => {
      setFocusedInput('')
      onBlurForEmail && onBlurForEmail(event.target.name)
    },
    [onBlurForEmail],
  )

  const onFocusFun = (event) => {
    setFocusedInput(event.target.name);
  }
  useEffect(() => {
    const currentForm = {
      ...formData,
    }
    const hasError = validate(currentForm, subscribeSchema(currentForm))
    !hasError ? setIsFormValid(true) : setIsFormValid(false)
  }, [formData])


  return (
    <ThemeContextExtend value={FormTheme}>
      <CouponsMainContainer bgImage={couponsData.bgimg}>
        <CouponsInnerContainer background="background-back">
          <CouponTitleContainer>
              <BrandLogoCouponsPage width={isDesktop ? '194px' : '136px'}/>
            <HeadingText>
              Exclusive Offers
            </HeadingText>
          </CouponTitleContainer>
          <CouponsTextContainer>
            <CouponsText >
              Sign up today and receive exclusive coupons, special offers, and the latest promotions straight to your inbox.
            </CouponsText>
          </CouponsTextContainer>
          <Form id="submitForm" onSubmit={onFormSubmit}>
            <Box>
              <FloatingInput
                id="emailAddress"
                name="emailAddress"
                type="email"
                style={{ background: "white", textIndent: "25px" }}
                icon={<OffersMailIconWMO />}
                label="Enter Your Email Address"
                value={formData.emailAddress || ''}
                aria-label="email"
                onChange={event => {
                  onInputChangeHandler('emailAddress', event.target.value)
                }}
                cross={formData.emailAddress?.length > 0 ? true : false}
                required={true}
                onBlur={onBlurFun}
                onFocus={onFocusFun}
                hasFocus={focusedInput === "emailAddress"}
                error={
                  errors.emailAddress
                    ? 'Enter a valid email address'
                    : ''
                }
                resetClick={event => {
                  resetClick('emailAddress', event)
                }}
                isWmoEnabled />
              <SignUpNowBtn
                id="submit"
                form="submitForm"
                primary
                custom
                hideBorder
                hoverBackground="hoverDarkSecondary"
                color="dark-2"
                label="Sign Up Now"
                type='submit'
                disabled={!isFormValid}>
              </SignUpNowBtn>
            </Box>
          </Form>
          <CouponLinksContainer>
            <LinkText href='/'>
              Continue Shopping
            </LinkText> 
            <LinkText href="/privacy-policy" target="_blank">
              Privacy Policy
            </LinkText>
          </CouponLinksContainer>
        </CouponsInnerContainer>
      </CouponsMainContainer>
    </ThemeContextExtend>
  )
}

export default CouponsWMO